import React from 'react';
import IconType from '~/reusable-components/icons/IconType';
import EyeClosedIcon from '~/reusable-components/icons/duotone/EyeClosedIcon';
import EyeOpenIcon from '~/reusable-components/icons/duotone/EyeOpenIcon';

interface VisibilityIconProps extends IconType {
  visibility: 'on' | 'off';
}
function VisibilityIcon({ visibility = 'off', ...props }: VisibilityIconProps) {
  if (visibility === 'on') {
    return <EyeOpenIcon variant="gray" {...props} />;
  }
  return <EyeClosedIcon variant="gray" {...props} />;
}

export default VisibilityIcon;
